import { Box } from '@parspec/pixel';

import KebabNestedMenu from 'src/features/BOM/shared/KebabNestedMenu';
import ImportProducts from '../shared/ImportProducts';

type BomTabHeaderProps = {
    setOpenManageColumnsPopup: React.Dispatch<React.SetStateAction<boolean>>;
    hasOption?: boolean
};

const BomTabHeader: React.FC<BomTabHeaderProps> = ({ setOpenManageColumnsPopup, hasOption }) => {
    const onManageColumnsClick = () => {
        setOpenManageColumnsPopup(true);
    };

    return (
        <Box display="flex" justifyContent="flex-end">
            <Box display="flex" gap={2} alignItems="center">
                <KebabNestedMenu onClickManageColumn={onManageColumnsClick} hasOption={hasOption} />
                <ImportProducts />
            </Box>
        </Box>
    );
};

export default BomTabHeader;
